// Generated by genversion.
export const version = '2.16.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@supabase/gotrue-js/dist/module/lib/version.js
// module id = null
// module chunks = 